'use client'

// Shared Configure modal (std/site/gallery/forum). Composes the modal shell
// with the skeleton SettingsInputs panel: a left section nav drives which pane
// is visible. The nav state is React-local — legacy does not read the active
// Configure tab; the input VALUES sync into the rough through SettingsInputs'
// own handlers exactly as before.
//
// The legacy `toggle-settings` event is deliberately NOT dispatched anywhere
// in this flow: its inline DOM swap (hide head/textarea rows, restyle the
// Configure button) belongs to the retired in-place layout. The mailbox
// settings dialog proved the rough-value path is sufficient for save.

import { useState } from 'react'
import type { EditorSettingsTab } from '@/msgdeskRuntime/contracts/editorModel'
import { SettingsInputs, settingsSectionTabs } from '../Settings/Settings'
import { EditorModal } from './EditorModal'

export function EditorConfigureModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [active, setActive] = useState<EditorSettingsTab>('display')

  return (
    <EditorModal
      open={open}
      onClose={onClose}
      title="Message settings"
      nav={settingsSectionTabs}
      activeNavId={active}
      onSelectNav={id => setActive(id as EditorSettingsTab)}
    >
      <SettingsInputs activePane={active} showTabs={false} />
    </EditorModal>
  )
}
